module.exports = "dist/logo_med.png?9446e2c75df4bbf588e0fcb465c813cd";